import { sanitize } from "dompurify"
import { i18n } from "src/boot/i18n"
import { getDB } from "src/db/databases"
import { useScanStore } from "src/stores/scanStore"
import { proofOfPresenceRequiredDialog } from "src/util/functions/dialogs"
import { showIdentify } from "src/util/functions/overlays"
import {
  Identifier,
  IdentifierActionReturn,
  IdentifierAssociationType,
  IdentifierEntityTarget,
  IdentifierScanAction,
} from "src/util/types/dataModels/identifier"

export function getEntityWithDesignation(
  associationType: IdentifierAssociationType,
  name: string
): string {
  const { t } = i18n.global

  const correctedName = sanitize(name)

  switch (associationType) {
    case "item":
      return t("identifyOverlay.subtitle_item", { name: correctedName })
    case "area":
      return t("identifyOverlay.subtitle_area", { name: correctedName })
    case "location":
      return t("identifyOverlay.subtitle_location", { name: correctedName })
  }
}

export function getIdentifierAssociationType(identifier: Identifier): IdentifierAssociationType {
  // There can only be one association of those 3
  if (identifier.item) {
    return "item"
  } else if (identifier.location) {
    return "location"
  } else {
    return "area"
  }
}

// TODO: Uncomment once we have them
export async function getIdentifierEntityName(identifier: Identifier): Promise<string | undefined> {
  const db = await getDB()
  if (identifier.item) {
    const result = await db.item.findOne(identifier.item).exec()
    return result?.designation
  } else if (identifier.location) {
    // const result = await db.location.findOne(identifier.location).exec()
    // return result?.designation
  } else if (identifier.area) {
    // const result = await db.area.findOne(identifier.area).exec()
    // return result?.designation
  }
}

export function getIdentifyTitle(scanPurpose: IdentifierScanAction, customTitle?: string): string {
  if (customTitle !== undefined) return customTitle

  const { t } = i18n.global

  switch (scanPurpose) {
    case "ASSOCIATE":
    case "ASSOCIATION_CHANGE":
      return t("identifyOverlay.title_associate")
    case "PROPOSE":
      return t("identifyOverlay.title_propose")
    case "SCAN":
    case "DISASSOCIATE":
      return t("identifyOverlay.title_scan")
    case "VERIFY":
      return t("identifyOverlay.title_verify")
  }
}

export async function verifyIdentifier(identifierEntity: IdentifierEntityTarget): Promise<boolean> {
  const scanStore = useScanStore()

  return new Promise((resolve) =>
    showIdentify("VERIFY", identifierEntity)
      .onOk((payload: IdentifierActionReturn<"VERIFY">) => {
        scanStore.setIdentifier(payload.data)

        resolve(true)
      })
      .onCancel(() => resolve(false))
  )
}

export async function checkScan(identifierEntity: IdentifierEntityTarget): Promise<boolean> {
  const scanStore = useScanStore()

  const isValid = scanStore.isScanValid(identifierEntity.entityType, identifierEntity.entityId)
  if (isValid) {
    return true
  }

  const userAccepts = await proofOfPresenceRequiredDialog(identifierEntity.entityType)
  if (!userAccepts) {
    return false
  }

  return await verifyIdentifier(identifierEntity)
}
